<template>

    <svg version="1.1" id="svg1" viewBox="0 0 157.77895 182.24894"
        xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg">
        <defs id="defs1" />

        <g inkscape:groupmode="layer" inkscape:label="Image" id="g1" transform="translate(-646.26868,275.12491)">
            <path id="rect17"
                style="opacity:1;fill:none;stroke:#e51326;stroke-width:8.31496;stroke-linecap:round;stroke-linejoin:round"
                d="m 735.23724,-138.6597 48.11928,0 v 21.83009 c 0,10.96708 -8.82909,19.796167 -19.79616,19.796167 h -76.80442 c -10.96707,0 -19.79616,-8.829087 -19.79616,-19.796167 v -21.83009 l 46.79291,0.071"
                sodipodi:nodetypes="ccsssscc" />
            <path
                style="fill:none;fill-opacity:1;stroke:#e51326;stroke-width:8.31496;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1"
                d="m 725.15815,-270.96743 c 24.98266,26.14661 40.2741,23.22905 56.76472,23.90782 3.83733,53.41127 -4.72695,97.99333 -56.76472,111.62489"
                id="path8" sodipodi:nodetypes="ccc" />
            <path
                style="fill:none;fill-opacity:1;stroke:#e51326;stroke-width:8.31496;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1"
                d="m 723.64634,-270.96743 c -24.98266,26.14661 -40.2741,23.22905 -56.76472,23.90782 -3.83733,53.41127 4.72695,97.99333 56.76472,111.62489"
                id="path9" sodipodi:nodetypes="ccc" />
            <path
                style="opacity:1;fill:none;fill-opacity:1;stroke:#e51326;stroke-width:8.31496;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1"
                d="m 702.85508,-225.50415 44.60614,44.60614" id="path10" />
            <path
                style="opacity:1;fill:none;fill-opacity:1;stroke:#e51326;stroke-width:8.31496;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1"
                d="m 747.46122,-225.50415 -44.60614,44.60614" id="path11" />
            <circle
                style="opacity:1;fill:#e51326;fill-opacity:1;stroke:none;stroke-width:8.11701;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1"
                id="circle20" cx="695.81567" cy="-117.84657" r="6.7787886" />
            <circle
                style="opacity:1;fill:#e51326;fill-opacity:1;stroke:none;stroke-width:8.11701;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1"
                id="circle21" cx="714.51263" cy="-117.84657" r="6.7787886" />
            <circle
                style="opacity:1;fill:#e51326;fill-opacity:1;stroke:none;stroke-width:8.11701;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1"
                id="circle22" cx="733.54004" cy="-117.84657" r="6.7787886" />
            <circle
                style="opacity:1;fill:#e51326;fill-opacity:1;stroke:none;stroke-width:8.11701;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1"
                id="circle23" cx="751.90643" cy="-117.84657" r="6.7787886" />
        </g>
    </svg>
</template>